import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectIsBuildersProjectsTabEnabled } from '../../selectors/selectIsBuildersProjectsTabEnabled';
import { BuildersProjectsBanner } from '../../components/BuildersProjectsBanner';

export const BuildersProjectsBannerContainer: React.FC = () => {
  const showBanner = useSelector(selectIsBuildersProjectsTabEnabled);

  if (!showBanner) {
    return null;
  }

  return <BuildersProjectsBanner />;
};
